<script>
	export let name;
	export let value;
	export let optionList;
	export let labelProperty = "label";
	export let valueProperty = "value";
	export let validator = null;
	export let validatorValue = null;
	export let validatorMessage = null;
	export let validatorTarget = ".radio-error";

	export let orientation = "vertical";

	export let required;
	export let disabled = null;
</script>

<div>
	{#if optionList && optionList.length}
		{#each optionList as option, i}
			<div class="custom-control custom-radio {orientation}">
				<input
					type="radio"
					id="{name}_{i}"
					bind:group={value}
					class="custom-control-input"
					value={option[valueProperty]}
					{name}
					data-validator={validator}
					data-validator-value={validatorValue}
					data-bouncer-message={validatorMessage}
					data-bouncer-target={validatorTarget}
					{required}
					{disabled}
				/>
				<label class="custom-control-label" for="{name}_{i}">{option[labelProperty]}</label>
			</div>
		{/each}
	{:else}
		No options
	{/if}
	<div class="radio-error"></div>
</div>

<style>
	.horizontal {
		display: inline-block;
		margin-right: 20px;
	}
</style>
